import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

export default function BackButton({ className = '' }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (pathname === '/portal' || pathname === '/portal/') return null;
  const back = () => { if (window.history.length > 1) navigate(-1); else navigate('/portal'); };
  return (
    <button onClick={back} aria-label="Indietro" className={`w-10 h-10 -ml-2 grid place-items-center ${className}`} data-testid="portal-mobile-back">
      <ChevronLeft size={24} />
    </button>
  );
}
